import React, { useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Image } from 'components/ui';
import PayPal from 'utils/PayPal';

/**
 * PayPal Pill Button - Release 4 Style
 * Renders as a pill-shaped button with PayPal logo
 */
const PaypalPill = props => {
    const {
        isPayPalEnabled, handlePaymentClick, width, height, imageHeight, imageScale
    } = props;

    useEffect(() => {
        if (isPayPalEnabled) {
            PayPal.preparePaypalCheckout();
        }
    }, [isPayPalEnabled]);

    // Don't render if PayPal is not enabled
    if (!isPayPalEnabled) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handlePaymentClick}
            data-at={Sephora.debug.dataAt('paypal_button')}
            aria-label='Pay with PayPal'
            css={styles}
            height={height || 44}
            minHeight={height || 44}
            width={width || ['151px', '151px', '100%']}
        >
            <Image
                src='/img/ufe/logo-paypal.svg'
                alt=''
                aria-hidden='true'
                height={imageHeight || '24px'}
                css={{
                    transform: `scale(${imageScale || 1})`
                }}
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#FFC439',
    borderRadius: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    '&:hover': {
        backgroundColor: '#FFD666'
    }
};

export default wrapFunctionalComponent(PaypalPill, 'PaypalPill');
